var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKalyanLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.485,
    height: 75,
    viewBox: "0 0 50.485 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.798,
    y1: 0.472,
    x2: 0.158,
    y2: 1.932,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fed600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ffcd0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#956b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30130d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.35,
    y1: 1.951,
    x2: -0.167,
    y2: 1.974,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ffcd0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b16b28"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kalyan_logo",
    transform: "translate(144 -338.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    d: "M-137.447,375.167-144,389.487c0,16.262,31.8,16.262,35.922,16.262h0c4.126,0,14.563,1.578,14.563,1.578-2.913-27.549-25.971-39.927-25.971-39.927Z",
    transform: "translate(0 6.173)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    "data-name": "Path 3962",
    d: "M-143.9,356.825v40.291a20.49,20.49,0,0,1,9.1-8.859h0c10.8-5.34,38.35-18.447,41.262-49.757,0,0-11.044,1.942-16.869,2.913h0C-115.987,342.262-143.779,342.5-143.9,356.825Z",
    transform: "translate(0.021 0)",
    fill: "url(#linear-gradient-2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalyanLogo);
export default __webpack_public_path__ + "static/media/kalyan_logo.9e9daceb5c8b62e6e87f13e88ece36f1.svg";
export { ForwardRef as ReactComponent };